module.exports = "div.content {\n    display: none;\n}\n\ndiv.content.show {\n    display: block;\n}"